<script>
import e4parent from "./e4parent";
export default {
  extends: e4parent,
  props: {
    units: String,
    legend: Boolean,
  },
  methods: {
    /* setOption() {
      this.isEmpty = true;
      this.$nextTick(() => {
        this.render(this.getMockData());
      });
    }, */
    getMockData() {
      let data = {
        legend: ["线上开展平均次数", "各类型应开展次数"], //图例
        x: [
          "支部党员大会",
          "支部委员会",
          "党小组会",
          "党课",
          "主题党日",
          "民主生活会",
        ], //x轴
        y: [
          0,
          5,
          10,
          15,
          20,
          25,
          30,
          35,
          40,
          45,
          50,
          55,
          60,
          65,
          70,
          75,
          80,
          85,
          90,
          95,
          100,
        ],
        //dataType 0 方形 1 线性
        data: [
          {
            name: "线上开展平均次数",
            value: [320, 302, 301, 334, 390, 330],
            dataType: 0,
          },
          {
            name: "各类型应开展次数",
            value: [120, 132, 101, 134, 90, 230],
            dataType: 1,
          },
        ],
      };
      return data;
    },
    getLegendData(data) {
      let legendData = [];
      let len = data.length;
      let iconMapping = ["rect", "line"];
      for (let i = 0; i < len; i++) {
        let item = data[i];
        let name = item.name;
        let dataType = item.dataType;
        let icon = iconMapping[dataType];
        legendData.push({
          name,
          icon,
        });
      }
      return legendData;
    },

    getEchartsOptions(data) {
      data = data.data;
      let currData = data.data;
      let colorData = this.colorData;
      let units = this.units || "";
      let option = {
        tooltip: {
          confine: true,
          formatter: function (data) {
            let info = "";
            let name = "";
            let len = data.length;
            for (let i = 0; i < len; i++) {
              const item = data[i];
              name = item.name;
              let value = item.value;
              let marker = item.marker;
              let seriesName = item.seriesName;
              seriesName = seriesName == "custom" ? "" : seriesName;
              info = info + "<br />" + marker + " " + seriesName + " " + value;
            }
            info = name + info;
            return info;
          },
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#333333",
            },
            label: {
              backgroundColor: "#666666",
            },
          },
        },
        color: colorData,
        grid: {
          top: "15%",
          left: "3%",
          right: "4%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#f0f0f0",
              opacity: 0.5,
            },
          },
          axisLabel: {
            show: true,
            color: this.chartsLabelColor || "#333333",
            // fontSize: 14,
            rotate: 40,
          },
        },
        yAxis: {
          name: units,
          type: "value",
          minInterval: 1,
          nameTextStyle: {
            color: this.chartsLabelColor || "#333333",
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "#f0f0f0",
              opacity: 0.5,
            },
          },
          axisLabel: {
            show: true,
            color: this.chartsLabelColor || "#333333",
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#f0f0f0",
              opacity: 0.5,
            },
          },
        },
        series: [],
      };
      let x = data.x;
      // let y = data.y;
      if (x) {
        option.xAxis.data = x;
      } else {
        // option.xAxis.data = y;
      }
      // 添加图列
      let legend = this.legend;
      if (legend) {
        option.grid.bottom = "20%";
        let legendData = this.getLegendData(currData);
        option.legend = {
          x: "center",
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          bottom: "5%",
          textStyle: {
            color: this.chartsLabelColor || "#333333"
          },
          data: legendData,
        };
      }
      let series = this.getEchartSeries(currData);
      option.series = series;
      return option;
    },
    getEchartSeries(data) {
      let series = [];
      let currData = data;
      let len = currData.length;
      let typeMapping = [
        {
          type: "bar",
        },
        {
          type: "line",
          symbol: "line",
          symbolSize: 20,
          color: "#F6BD15",
          itemStyle: {
            normal: {
              barBorderRadius: 0,
              label: {
                show: false,
              },
              lineStyle: {
                opacity: 0,
              },
            },
          },
        },
      ];
      for (let i = 0; i < len; i++) {
        let item = currData[i];
        let name = item.name;
        let value = item.value;
        let dataType = item.dataType;
        if (value) {
          if (Array.isArray(value)) {
            //
          } else {
            value = [value];
          }
        }
        let typeData = typeMapping[dataType];
        let serie = {
          stack: 1,
          type: "bar",
          name: name,
          barWidth: 20,
          data: value,
          ...typeData,
        };
        series.push(serie);
      }
      return series;
    },
  },
};
</script>